import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ShieldCheck, Tag } from 'lucide-react';
declare global {
  interface Window {
    fbq: any;
  }
}
export function PricingSection() {
  const handleCheckout = () => {
    // Fire AddToCart event
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'The 7pm Menopause Sleep Reset',
        content_ids: ['45826731376830'],
        content_type: 'product',
        value: 7.0,
        currency: 'USD'
      });
    }
    // Redirect to Shopify
    window.location.href = 'https://glowliftessence.com/cart/45826731376830:1';
  };
  return <section id="pricing" className="py-24 bg-[#FC8EAC] text-white" data-id="element-108">
      <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-109">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-110">
          <h2 className="text-3xl md:text-5xl font-bold mb-6 font-serif" data-id="element-111">
            Get The 7pm Menopause Sleep Reset
          </h2>
          <p className="text-xl text-white/90 mb-10 max-w-2xl mx-auto" data-id="element-112">
            Stop the night from hijacking tomorrow. You don't need a new you.
            You need the right order.
          </p>

          <div className="bg-white text-[#2C2C2C] rounded-2xl p-8 md:p-12 max-w-lg mx-auto shadow-2xl relative overflow-hidden" data-id="element-113">
            <div className="absolute top-4 right-4 bg-[#FC8EAC] text-white px-4 py-2 rounded-full flex items-center gap-2 font-bold text-sm shadow-lg" data-id="element-114">
              <Tag className="w-4 h-4" data-id="element-115" />
              <span data-id="element-116">65% OFF</span>
            </div>

            <div className="mb-6" data-id="element-117">
              <div className="flex justify-center items-center gap-3 mb-2" data-id="element-118">
                <span className="text-2xl text-gray-400 line-through font-semibold" data-id="element-119">
                  $19
                </span>
                <span className="text-5xl font-bold text-[#FC8EAC]" data-id="element-120">$7</span>
                <span className="text-gray-500" data-id="element-121">USD</span>
              </div>
              <p className="text-sm text-[#FC8EAC] font-semibold" data-id="element-122">
                Limited Time Offer
              </p>
            </div>

            <p className="text-[#4A4A4A] mb-8" data-id="element-123">
              One-time payment. Instant digital download.
            </p>

            <Button fullWidth className="mb-4 text-lg py-6" onClick={handleCheckout} data-id="element-124">
              Download The System Now
            </Button>

            <div className="flex items-center justify-center text-sm text-[#666] gap-2" data-id="element-125">
              <ShieldCheck className="w-4 h-4 text-[#FC8EAC]" data-id="element-126" />
              <span data-id="element-127">Secure checkout via Stripe</span>
            </div>
          </div>

          <p className="mt-8 text-white/80 text-sm max-w-md mx-auto" data-id="element-128">
            That's less than another bottle of something that may or may not
            work—and this gives you a plan you can reuse whenever sleep slips.
          </p>
        </motion.div>
      </div>
    </section>;
}